// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__RMxEt","boxTitle":"Qualiphy_boxTitle__15I3p","box":"Qualiphy_box__2ptwz","toggleWrap":"Qualiphy_toggleWrap__y4yOU"};